import { render } from "./Diagnostiek.vue?vue&type=template&id=ce93701c&scoped=true"
const script = {}

import "./Diagnostiek.vue?vue&type=style&index=0&id=ce93701c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\reino\\Desktop\\testt\\de-tol\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce93701c"]])

export default __exports__